module.exports = __webpack_public_path__ + "static/media/proj1_img3.04974209.jpg";